import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../theme';

// No owning component — rendered directly by ReportsDialog.jsx (dialogs/) and
// InvoiceContainer.jsx (dialogs/invoice/), two unrelated dialog features.
export const useDialogToolbarStyles = createStyles(() => ({
  toolbarTitle: {
    fontFamily: ThemeFont.FONT_FAMILY6,
    fontSize: ThemeFont.FONT_SIZE_40,
    color: ThemeColors.COLOR_GREY6,
  },
}));
